const METHODFI_BLOCKED_STATES = new Set(['PA', 'NH', 'VA', 'HI', 'NY', 'CA']);

export const isStateEligibleForMethodFi = (state: string | null | undefined): boolean => {
  if (!state?.trim()) return false;
  return !METHODFI_BLOCKED_STATES.has(state.trim().toUpperCase());
};
